export const NECK = [
  {
    name: 'Amulet of Torture',
    slot: 'neck',
    regions: ['Kandarin'],
    requirements: [{ skill: 'Defence', level: 75 }],
    bonuses: {
      attack:  { stab: 15, slash: 15, crush: 15, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 10, rangedStrength: 0, magicDamage: 0, prayer: 2 },
    },
  },
  {
    name: 'Necklace of Anguish',
    slot: 'neck',
    regions: ['Kandarin'],
    requirements: [{ skill: 'Ranged', level: 75 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 15 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 5, magicDamage: 0, prayer: 2 },
    },
  },
  {
    name: 'Occult Necklace',
    slot: 'neck',
    regions: ['Kandarin'],
    requirements: [{ skill: 'Magic', level: 60 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 12, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 5, prayer: 2 },
    },
  },
  {
    name: 'Amulet of Blood Fury',
    slot: 'neck',
    regions: ['Morytania'],
    requirements: [{ skill: 'Defence', level: 75 }],
    bonuses: {
      attack:  { stab: 10, slash: 10, crush: 10, magic: 10, ranged: 10 },
      defence: { stab: 15, slash: 15, crush: 15, magic: 15, ranged: 15 },
      other:   { meleeStrength: 8, rangedStrength: 0, magicDamage: 0, prayer: 5 },
    },
  },
  {
    name: 'Amulet of Rancour',
    slot: 'neck',
    regions: ['Morytania'],
    requirements: [{ skill: 'Defence', level: 75 }],
    bonuses: {
      attack:  { stab: 25, slash: 25, crush: 25, magic: -6, ranged: -8 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 12, rangedStrength: 0, magicDamage: 0, prayer: 2 },
    },
  },
  {
    name: 'Amulet of Fury',
    slot: 'neck',
    regions: ['Karamja'],
    requirements: [{ skill: 'Defence', level: 40 }],
    bonuses: {
      attack:  { stab: 10, slash: 10, crush: 10, magic: 10, ranged: 10 },
      defence: { stab: 15, slash: 15, crush: 15, magic: 15, ranged: 15 },
      other:   { meleeStrength: 8, rangedStrength: 0, magicDamage: 0, prayer: 5 },
    },
  },
  {
    name: 'Bonecrusher Necklace',
    slot: 'neck',
    regions: ['Kourend'],
    requirements: [{ skill: 'Prayer', level: 70 }],
    bonuses: {
      attack:  { stab: 10, slash: 10, crush: 10, magic: 10, ranged: 10 },
      defence: { stab: 2, slash: 2, crush: 2, magic: 2, ranged: 2 },
      other:   { meleeStrength: 2, rangedStrength: 0, magicDamage: 0, prayer: 12 },
    },
  },
  {
    name: 'Berserker Necklace',
    slot: 'neck',
    regions: ['Karamja'],
    requirements: [],
    bonuses: {
      attack:  { stab: -10, slash: -10, crush: -10, magic: 0, ranged: 0 },
      defence: { stab: -20, slash: -20, crush: -20, magic: -20, ranged: -20 },
      other:   { meleeStrength: 7, rangedStrength: 0, magicDamage: 0, prayer: 3 },
    },
  },
  {
    name: 'Amulet of Glory',
    slot: 'neck',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 10, slash: 10, crush: 10, magic: 10, ranged: 10 },
      defence: { stab: 3, slash: 3, crush: 3, magic: 3, ranged: 3 },
      other:   { meleeStrength: 6, rangedStrength: 0, magicDamage: 0, prayer: 3 },
    },
  },
  {
    name: 'Salve Amulet (ei)',
    slot: 'neck',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 3, slash: 3, crush: 3, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 3 },
    },
  },
  {
    name: 'Amulet of the Damned',
    slot: 'neck',
    regions: ['Morytania'],
    requirements: [{ skill: 'Defence', level: 40 }],
    bonuses: {
      attack:  { stab: 10, slash: 10, crush: 10, magic: 10, ranged: 10 },
      defence: { stab: 3, slash: 3, crush: 3, magic: 3, ranged: 3 },
      other:   { meleeStrength: 6, rangedStrength: 0, magicDamage: 0, prayer: 3 },
    },
  },
  {
    name: 'Holy Necklace',
    slot: 'neck',
    regions: ['Varlamore'],
    requirements: [{ skill: 'Prayer', level: 70 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 2, slash: 2, crush: 2, magic: 2, ranged: 2 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 8 },
    },
  },
  {
    name: 'Amulet of Strength',
    slot: 'neck',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 10, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Amulet of Power',
    slot: 'neck',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 6, slash: 6, crush: 6, magic: 6, ranged: 6 },
      defence: { stab: 6, slash: 6, crush: 6, magic: 6, ranged: 6 },
      other:   { meleeStrength: 6, rangedStrength: 0, magicDamage: 0, prayer: 1 },
    },
  },
  {
    name: 'Dragonbone Necklace',
    slot: 'neck',
    regions: ['Fremennik'],
    requirements: [{ skill: 'Prayer', level: 70 }],
    bonuses: {
      attack:  { stab: 10, slash: 10, crush: 10, magic: 10, ranged: 10 },
      defence: { stab: 2, slash: 2, crush: 2, magic: 2, ranged: 2 },
      other:   { meleeStrength: 2, rangedStrength: 0, magicDamage: 0, prayer: 12 },
    },
  },
];
